//
//
//
//
//
//
//
//
//
//
//
//
//

import uuidMixin from '../libs/mixin_uuid';

export default {
  name: 'InlineCheckBox',
  mixins: [uuidMixin],
  props: {
    value: [Boolean],
    disabled: Boolean,
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  methods: {
    handleChange(event) {
      var value = event.target.checked;
      this.$emit('input', value);
    },
  },
  watch: {
    value(val) {
      this.currentValue = val;
    },
  },
};
